import { api } from "../api/client";

export interface MergeTagOption {
    tag: string;
    label: string;
    fallback?: string;
    sample?: string;
    group?: string;
}

/** Offline fallback only — the server's /api/v1/merge-tags is the source of
 * truth (built-in defaults + tenant merge_tag_sets). */
const FALLBACK_TAGS: MergeTagOption[] = [
    { tag: "contact.first_name", label: "First name", fallback: "there" },
    { tag: "contact.email", label: "Email address" },
    { tag: "unsubscribe_url", label: "Unsubscribe URL" },
];

let cache: MergeTagOption[] | null = null;
let pending: Promise<MergeTagOption[]> | null = null;

export function fetchMergeTags(): Promise<MergeTagOption[]> {
    if (cache) return Promise.resolve(cache);
    pending ??= api
        .get<{ tags: MergeTagOption[] }>("/api/v1/merge-tags")
        .then((r) => {
            cache = r.tags;
            return r.tags;
        })
        .catch(() => FALLBACK_TAGS)
        .finally(() => {
            pending = null;
        });
    return pending;
}
